<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="mainBread"
          >
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>账号管理</el-breadcrumb-item>
          </el-breadcrumb>
          <el-form
            ref="formselect"
            v-model="formselect"
            :inline="true"
            class="queryform_div"
          >
            <el-form-item label="客户名称">
              <el-input
                class="queryform"
                v-model="formselect.name"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small">{{
                $t("button.query")
              }}</el-button>
              <el-button size="small">{{ $t("button.reset") }}</el-button>
            </el-form-item>
          </el-form>

          <template>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="dialogAdd = true"
              style="margin-bottom: 10px"
              >新增账号</el-button
            >
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="50"
                >
                </el-table-column>
                <el-table-column prop="name" label="账号名称" min-width="10%">
                </el-table-column>

                <el-table-column
                  :label="$t('title.operate')"
                  width="130"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      circle
                      size="mini"
                      @click="dialogEditClient = true"
                    ></el-button>
                    <el-button
                      type="warning"
                      icon="el-icon-lock"
                      circle
                      size="mini"
                      @click="dialogEditPass = true"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                      >
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          circle
                          size="mini"
                          slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <el-dialog title="新增账号" :visible.sync="dialogAdd" width="60%" top="5vh">
      <el-form ref="addform" :model="addform" label-width="200px">
        <el-form-item label="账号名称">
          <el-input
            v-model="addform.name"
            style="width: 200px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="设置密码">
          <el-input
            v-model="addform.pass"
            type="password"
            style="width: 200px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="onSubmit">确定</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogEditPass"
      width="60%"
      top="5vh"
    >
      <el-form ref="form" :model="form" label-width="200px">
        <el-form-item label="账号名称">
          <el-input
            style="width: 200px"
            value="Sam Zhang"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="请输入原密码">
          <el-input
            v-model="form.pass1"
            type="password"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="请输入新密码">
          <el-input
            v-model="form.pass2"
            type="password"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="请再次输入新密码">
          <el-input
            v-model="form.pass3"
            type="password"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="onSubmit">确定</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "index",

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  data() {
    return {
      dialogAdd: false,
      dialogEditPass: false,
      formselect: {
        name: "",
      },
      tableData1: [
        {
          name: "Sam Zhang",
        },
        {
          name: "June Sun",
        },
        {
          name: "test1",
        },
        {
          name: "test2",
        },
        {
          name: "test3",
        },
        {
          name: "test4",
        },
      ],
      addform: {
        name: "",
        pass: "",
      },
      form: {
        name: "",
        pass1: "",
        pass2: "",
        pass3: "",
      },
    };
  },

  methods: {
    handleAccredit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    onSubmit() {},
  },
};
</script>


